<template>
  <div>
    <!-- <v-row id="product__rowpadding" v-if="communication_type === 1"> -->
    <v-row id="product__rowpadding" v-if="con1()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >{{ sign_on_label }} #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-textarea
          :counter="counter"
          :rules="incentive_rules"
          name="input-7-1"
          outlined
          dense
          v-model="sign_on_incentive"
        />
      </v-col>
    </v-row>
    <!-- <v-row id="product__rowpadding" v-if="communication_type === 1"> -->
    <v-row id="product__rowpadding" v-if="con1() || con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Ongoing Incentive :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-textarea
          v-if="sign_on_label === 'Incentive'"
          name="input-7-1"
          outlined
          dense
          disabled
          v-model="ongoing_incentive"
        />
        <v-textarea
          v-else
          name="input-7-1"
          outlined
          dense
          v-model="ongoing_incentive"
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Type #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select
          :items="all_sign_on_incentive_type"
          dense
          v-model="sign_on_incentive_type"
          outlined
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Value #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_value" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Accelerator Per #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_acceleretor_per" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Accelerator Type #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select
          :items="all_sign_on_accelerator_type"
          outlined
          dense
          v-model="sign_on_acceleretor_type"
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Max award #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_max_award" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Maximum Spend #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_max_spend" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Minimum Spend #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_min_spend" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Window (months) #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_window_month" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Limited to Specific Category #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-radio-group
          :mandatory="false"
          row
          v-model="sign_on_limit_specific_category"
        >
          <v-radio label="Yes" :value="1"></v-radio>
          <v-radio label="No" :value="0"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Fixed date #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-radio-group :mandatory="false" row v-model="sign_on_fixed_date">
          <v-radio label="Yes" :value="1"></v-radio>
          <v-radio label="No" :value="0"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Incentive1",
  data: () => ({
    c: 1,
  }),
  props : ["counter","incentive_rules"],
  computed: {
    ...mapGetters({
      communication_type: "ProductData/getCommunicationType",
      all_sign_on_accelerator_type: "ProductData/getAllSignOnAcceleratorType",
      all_sign_on_incentive_type: "ProductData/getAllSignOnIncentiveData",
    }),
    sign_on_label: function () {
      return this.$productutils.hasInvestmentOrInsurance(this)
        ? "Incentive"
        : "Sign-on Incentive";
    },
    sign_on_incentive: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn1Incentive"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1Incentive", o);
      },
    },
    ongoing_incentive: {
      get: function () {
        return this.$store.getters["ProductData/getOngoingIncentive"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setOngoingIncentive", o);
      },
    },
    sign_on_incentive_type: {
      get: function () {
        return parseInt(
          this.$store.getters["ProductData/getSignOn1IncentiveType"]
        );
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1IncentiveType", o);
      },
    },
    sign_on_incentive_value: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn1IncentiveValue"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1IncentiveValue", o);
      },
    },
    sign_on_acceleretor_per: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn1AcceleretorPer"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1AcceleretorPer", o);
      },
    },
    sign_on_acceleretor_type: {
      get: function () {
        return parseInt(
          this.$store.getters["ProductData/getSignOn1AcceleretorType"]
        );
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1AcceleretorType", o);
      },
    },
    sign_on_max_award: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn1MaxAward"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1MaxAward", o);
      },
    },
    sign_on_incentive_max_spend: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn1IncentiveMaxSpend"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1IncentiveMaxSpend", o);
      },
    },
    sign_on_incentive_min_spend: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn1IncentiveMinSpend"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1IncentiveMinSpend", o);
      },
    },
    sign_on_incentive_window_month: {
      get: function () {
        return this.$store.getters[
          "ProductData/getSignOn1IncentiveWindowMonth"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1IncentiveWindowMonth", o);
      },
    },
    sign_on_limit_specific_category: {
      get: function () {
        if (
          this.$store.getters["ProductData/getSignOn1LimitSpecificCategory"] ==
          ""
        )
          this.$store.dispatch(
            "ProductData/setSignOn1LimitSpecificCategory",
            0
          );
        return this.$store.getters[
          "ProductData/getSignOn1LimitSpecificCategory"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1LimitSpecificCategory", o);
      },
    },
    sign_on_fixed_date: {
      get: function () {
        if (this.$store.getters["ProductData/getSignOn1FixedDate"] == "") {
          this.$store.dispatch("ProductData/setSignOn1FixedDate", 0);
        }
        //this.$store.dispatch("ProductData/setSignOn1FixedDate", o);
        return this.$store.getters["ProductData/getSignOn1FixedDate"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn1FixedDate", o);
      },
    },
  },
  methods: {
    con1: function () {
      return this.$productutils.condition1(this);
    },
    con2: function () {
      return this.$productutils.condition2(this);
    },
  },
};
</script>